function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 8.158C8 8.071 8.07 8 8.158 8 16.908 8 24 15.092 24 23.842c0 .087-.07.158-.158.158H9a1 1 0 01-1-1V8.158z",
  fill: "#FC4F52"
});

var SvgIconQuarterActive = function SvgIconQuarterActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggOC4xNTg0MkM4IDguMDcwOTMgOC4wNzA5MyA4IDguMTU4NDIgOEMxNi45MDc1IDggMjQgMTUuMDkyNSAyNCAyMy44NDE2QzI0IDIzLjkyOTEgMjMuOTI5MSAyNCAyMy44NDE2IDI0SDlDOC40NDc3MiAyNCA4IDIzLjU1MjMgOCAyM1Y4LjE1ODQyWiIgZmlsbD0iI0ZDNEY1MiIvPgo8L3N2Zz4K";
export { SvgIconQuarterActive as ReactComponent };